import { FC, useState } from 'react';

import { Head, router } from '@inertiajs/react';

import { EmptyBlog } from './EmptyBlog';
import { BlogHeader } from './HeaderBlog';
import { Posts } from './Posts';
import { InfiniteScrollTrigger } from '../../components/shared/InfiniteScrollTrigger';
import { Routes } from '../../models/routes';
import { BlogPost } from '../../types';

type BlogIndexProps = {
    blogPosts: BlogPost[];
    nextPage: number | null;
};

const BlogIndex: FC<BlogIndexProps> = ({ blogPosts, nextPage }) => {
    const [loading, setLoading] = useState(false);

    const loadMore = () => {
        if (!nextPage || loading) return;

        router.get(
            Routes.Blog,
            { page: nextPage },
            {
                preserveScroll: true,
                preserveState: true,
                preserveUrl: true,
                only: ['blogPosts', 'nextPage'],
                onStart: () => setLoading(true),
                onFinish: () => setLoading(false),
            },
        );
    };

    return (
        <>
            <Head title="Блог | CartOn" />

            <div className="container mx-auto max-w-6xl py-10">
                <div className="max-w-[64rem]">
                    <BlogHeader />

                    {blogPosts?.length > 0 ? (
                        <Posts posts={blogPosts} />
                    ) : (
                        <EmptyBlog />
                    )}

                    {blogPosts?.length > 0 && nextPage && (
                        <InfiniteScrollTrigger
                            className="mt-8"
                            loading={loading}
                            onLoadMore={loadMore}
                        />
                    )}
                </div>
            </div>
        </>
    );
};

export default BlogIndex;
